module.exports = __webpack_public_path__ + "img/4-5.451f5117.svg";